import { useMemo } from 'react'
import { isEmpty, isNonNullish } from 'remeda'
import { useMediaQuery } from 'usehooks-ts'
import { getMediaSources } from '@velasca/utils/get-media-sources'
import { MaxWidthContainer } from '../MaxWidthContainer/MaxWidthContainer'
import { SansTitle } from '../SansTitle/SansTitle'
import { SerifTitle } from '../SerifTitle/SerifTitle'
import {
  Background,
  Description,
  Frame,
  Image,
  ImageWrapper,
} from './RedirectBlock.styles'
import type { RedirectBlockProps } from './RedirectBlock.types'

export const RedirectBlock = ({
  mobileImage,
  desktopImage,
  title,
  upperTitle,
  url,
  targetBlank,
}: RedirectBlockProps): JSX.Element | null => {
  const mediaSources = useMemo(
    () =>
      mobileImage && desktopImage && getMediaSources(mobileImage, desktopImage),
    [mobileImage, desktopImage],
  )
  const fallbackImage = mediaSources ? mediaSources[0] : null
  const isMinWidth768px = useMediaQuery('(min-width: 768px)')

  if (!mobileImage && !desktopImage && !title && !upperTitle && !url) {
    return null
  }

  return (
    <Background>
      <MaxWidthContainer>
        <Frame>
          <ImageWrapper>
            {isNonNullish(fallbackImage) && !isEmpty(fallbackImage) && (
              <Image
                lazyload
                lqip
                mediaSources={mediaSources}
                alt={fallbackImage.alt}
                sources={fallbackImage.sources}
                imgSrc={fallbackImage.imgSrc}
              />
            )}
          </ImageWrapper>
          <Description href={url} target={targetBlank ? '_blank' : '_self'}>
            <SansTitle
              tracking="wide"
              size={isMinWidth768px ? 'base' : 'sm'}
              as="h3"
            >
              {upperTitle}
            </SansTitle>
            <SerifTitle as="h2" size={isMinWidth768px ? 'xl' : 'md'}>
              {title}
            </SerifTitle>
          </Description>
        </Frame>
      </MaxWidthContainer>
    </Background>
  )
}
